import { render } from "./Navbar.vue?vue&type=template&id=683d05a2&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=683d05a2&scoped=true&lang=css"

import exportComponent from "/home/alexeyza/git/chargd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-683d05a2"]])

export default __exports__